(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "67bd424f879ed2a12008dff4";
              window.beaePageSetting.pageTitle = "Request a Service"; 
              window.beaePageSetting.pageType = "page";

          let js_CL76OOLV = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-xth5qvs3section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-xth5qvs3',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-xth5qvs3');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-xth5qvs3: ', ex)
      };
    

      try {
        let argid = 'beae-qj9zegsiblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-qj9zegsi',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-qj9zegsi');
        args.el = args.els[0];
        ((P) => { var z;let H=(z=P.el)==null?void 0:z.querySelectorAll(".beae-x-text a");H==null||H.forEach(R=>{let O=R==null?void 0:R.getAttribute("href");R&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&R.addEventListener("click",I=>{let A=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),I.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-qj9zegsi: ', ex)
      };
    

      try {
        let argid = 'beae-vj1im3opblock-form',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-vj1im3op',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-vj1im3op');
        args.el = args.els[0];
        ((g) => { const h=window.location.href.indexOf("contact_posted=true")!==-1,u=g.el.querySelector("form");g.el.querySelector(".beae-btn-pr");const f=g.el.querySelectorAll("input","select","button","textarea","checkbox","radio"),b=g.el.querySelector(".btn-lightbox-form > button");!h&&g.mode.value!=="builder"&&(g.el.querySelector(".beae-form-success-message").style="display: none"),h&&g.afterSubmitting=="redirect"&&g.redirect&&(g.el.querySelector(".beae-form-success-message").style="display: block",window.location.href=g.redirect);const C=[];u&&u.addEventListener("submit",m=>{m.preventDefault();for(let _=0;_<f.length;_++)C.push({fieldKey:f[_].name,fieldType:f[_].type,fieldValue:f[_].value})}),b&&(b.onclick=()=>{const m=document.createElement("div");m.innerHTML=u.outerHTML||"",window.BeaePopupLibrary.createPopup(m,{layout:"center",layoutMobile:"bottom",width:"500px",id:g.id})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-vj1im3op: ', ex)
      };
    

      try {
        let argid = 'beae-za7nleq1block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-za7nleq1',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-za7nleq1');
        args.el = args.els[0];
        ((P) => { var z;let H=(z=P.el)==null?void 0:z.querySelectorAll(".beae-x-text a");H==null||H.forEach(R=>{let O=R==null?void 0:R.getAttribute("href");R&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&R.addEventListener("click",I=>{let A=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),I.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-za7nleq1: ', ex)
      };
    }; if (window.BEAEBASE) {js_CL76OOLV()} else {window.BEAEPAGEJS.push(js_CL76OOLV)} })(); 